export default __webpack_public_path__ + "static/Litepaper - Vietnam-beb4cefa25f9beb241d25e2516aa3ff7.pdf";